import React from 'react';
import { DatePicker, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import SupplierRegionsLocationsTreeSelect from '../regions_tree_select/SupplierRegionsLocationsTreeSelect';

const LOCATION_TARGET_COLLECTION = 'wrenchModeLogsLocationFilter';

interface WrenchModeDetailHeaderProps {
	selectedMonth: moment.Moment;
	onMonthChange: (date: moment.Moment) => void;
	locationIds: number[] | undefined;
	onLocationChange: (ids: number[] | undefined) => void;
}

const WrenchModeDetailHeader: React.FC<WrenchModeDetailHeaderProps> = ({
	selectedMonth,
	onMonthChange,
	locationIds,
	onLocationChange,
}) => {
	return (
		<div className="flex items-center gap-s p-xs">
			<div className="flex items-center gap-2">
				<DatePicker
					picker="month"
					value={selectedMonth}
					format={(date) => date.format('MMM YYYY')}
					onChange={(date) => {
						if (date) onMonthChange(date);
					}}
					allowClear={false}
					style={{ width: 220 }}
				/>
			</div>
			<div style={{ width: 300 }}>
				<SupplierRegionsLocationsTreeSelect
					targetCollectionName={LOCATION_TARGET_COLLECTION}
					placeholder="Filter by location"
					mode="multiple"
					value={locationIds}
					onChange={(val) => {
						const ids = Array.isArray(val) && val.length > 0 ? val.map(Number) : undefined;
						onLocationChange(ids);
					}}
				/>
			</div>
		</div>
	);
};

export default WrenchModeDetailHeader;
